var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container complete" }, [
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("finished_page.congrats")) },
    }),
    _c("p", {
      domProps: { innerHTML: _vm._s(_vm.$t("finished_page.finished_text")) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }